import React from "react";
import Button from "@amzn/meridian/esm/components/button";
import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Modal, { ModalFooter } from "@amzn/meridian/esm/components/modal";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme/theme";
import Link from "@amzn/meridian/esm/components/link";

import aimsTheme from "../styles/meridian-theme-aims.json";
import LogManager from "../utils/logManager";
import { openUrl } from "../utils/zoomSdkUtils";
import disclaimerIcon from "../images/disclaimer_icon.svg";
import { THEME_COLOR } from "../styles/colors";

const AMAZON_LEGAL_POLICY_URL = "https://policy.a2z.com/docs/693659/publication/";
const AIMS_WIKI_URL = "https://w.amazon.com/bin/view/UnifiedCommunications/MeetingSummaries/AiMS/"

const InformSummarizeModal = ({ isOpen, onClose, onConfirm }) => {
  const handleOK = () => {
    console.log("User confirmed summarization in modal.");
    LogManager.info("User confirmed summarization in modal.");
    onConfirm();
  };


  return (
    <Theme
      palette={aimsTheme}
      tokens={{
        modalHeaderBackgroundColor: THEME_COLOR.LIGHT_TEAL,
        modalHeaderSpacingInsetTop: "0px",
        modalHeaderSpacingInsetBottom: "0px",
        modalHeaderFontSize: "8px",
        modalHeaderMinHeight: "8px",
        modalFooterBorderColor: THEME_COLOR.WHITE,
      }}
    >
      <Modal
        open={isOpen}
        closeLabel={null}
        shouldCloseOnOverlayClick={false}
        aria-describedby="modal-description"
        fullscreenBreakpoint="0"
        title=" "
        bodySpacingInset="300"
        scrollContainer="viewport"
      >
        <Column spacing="none" height="52vh" width="276px">
          {/*Title*/}
          <Column alignmentHorizontal="center" height="24px">
            <Theme tokens={{ textListSpacingVertical: "0px" }}>
              <Text type="h200" alignment="center">
                Amazon Meetings Summary
              </Text>
            </Theme>
          </Column>

          <Column height="24px" />

          {/*disclaimer Icon*/}
          <Column alignmentHorizontal="center">
            <img src={disclaimerIcon} alt="disclaimerIcon" style={{ display: "block", margin: "auto", maxWidth: "100%", height: "auto" }} />
          </Column>

          <Column height="24px" />

          {/*Detail disclaimer in bullet points*/}
          <Box width="244px" height="228px">
            <Text type="b100">
              <ul>
                <li>
                  Review {" "}
                  <Link type="primary" onClick={() => openUrl(AMAZON_LEGAL_POLICY_URL)} style={{ color: THEME_COLOR.MUTED_TEAL }}>
                    Amazon’s Recording, Transcription, and Summarization Policy
                  </Link>{" "}
                  for permitted meeting types
                </li>
                <li>Notify attendees when meetings are being summarized</li>
                <li>
                  Meeting organizers are responsible for compliance. Refer to wiki for guidelines {" "}
                  <Link type="primary" onClick={() => openUrl(AIMS_WIKI_URL)} style={{ color: THEME_COLOR.MUTED_TEAL }}>
                    Amazon Meetings Summary wiki
                  </Link>
                </li>
              </ul>
            </Text>
          </Box>
        </Column>
        <ModalFooter>
          <Row alignmentHorizontal="end" widths="fit">
            <Button type="link" size="small" onClick={onClose}>
              Cancel
            </Button>
            <Button type="primary" size="small" minWidth="64px" onClick={handleOK}>
              OK
            </Button>
          </Row>
        </ModalFooter>
      </Modal>
    </Theme>
  );
};

export default InformSummarizeModal;